export default "__VITE_ASSET__DprjqVTy__"